import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { IonicVue } from "@ionic/vue";
import "@ionic/vue/css/core.css";
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";
import "./theme/variables.css";
import "./theme/core.css";
import "animate.css";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "quill/dist/quill.snow.css";

// Impor Firebase
import { initializeApp } from "firebase/app";

// Konfigurasi Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBOJvFdHizPLr_m-MVklgrJ2CxgUKoUSwg",
  authDomain: "simpelabsensi.firebaseapp.com",
  projectId: "simpelabsensi",
  storageBucket: "simpelabsensi.firebasestorage.app",
  messagingSenderId: "243814805882",
  appId: "1:243814805882:web:f9ce31f4551197c19ea6c3",
  measurementId: "G-RBTRPRPKWB"
};

// Inisialisasi Firebase
const firebaseApp = initializeApp(firebaseConfig);

const app = createApp(App)
  .component("swiper", Swiper)
  .component("swiper-slide", SwiperSlide)
  .use(IonicVue, {
    mode: "ios",
  })
  .use(router);

// Menetapkan firebaseApp ke objek app Vue
app.config.globalProperties.$firebase = firebaseApp;

router.isReady().then(() => {
  app.mount("#app");
});
